export default __webpack_public_path__ + "static/base-plus-scheda-tecnica-b4a2d37a4364417c2c56caf697b28f64.pdf";